var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 2C12.3008 2.04463 8.76575 3.53395 6.14985 6.14985C3.53395 8.76575 2.04463 12.3008 2 16C2.04463 19.6992 3.53395 23.2343 6.14985 25.8501C8.76575 28.466 12.3008 29.9554 16 30C19.6992 29.9554 23.2343 28.466 25.8501 25.8501C28.466 23.2343 29.9554 19.6992 30 16C29.9554 12.3008 28.466 8.76575 25.8501 6.14985C23.2343 3.53395 19.6992 2.04463 16 2ZM24 17H17V24H15V17H8V15H15V8H17V15H24V17Z",
  fill: "#033266"
});

function SvgActiveAddBtn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveAddBtn);
export default __webpack_public_path__ + "static/media/active-add-btn.cfa27971731f5b9a8ac21beb2b1e0460.svg";
export { ForwardRef as ReactComponent };